import React from 'react';
import { Spinner } from '@insurancemenu/imenu-components-lib';
import clsx from 'clsx';
import { createStyles } from './styles';

interface FormSpinnerProps {
  display: boolean;
  size?: string;
  semiTransparentBg?: boolean;
  styles?: string;
  spinnerStyle?: string;
  'data-test-id'?: string;
}

const FormsSpinner: React.FC<FormSpinnerProps> = (props) => {
  const { display, size, semiTransparentBg = true, styles = '', spinnerStyle = '' } = props;
  const classes = createStyles(semiTransparentBg);
  return display ? (
    <div className={clsx(classes.spinnerWrapper, styles)}>
      <Spinner size={size || '8rem'} className={spinnerStyle} data-test-id={props['data-test-id']} />
    </div>
  ) : null;
};

export default FormsSpinner;
